import { useCallback, useState } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

export type UseUpdateSupportersReturn = ModelHookResult<
	{
		shouldShowSuggestedTemplateNotice: boolean;
		isTemplateFilled: boolean;
	},
	{
		handleUserClickSuggestionAi: () => void;
	}
>;

export function useUpdateSupporters(): UseUpdateSupportersReturn {
	const [hasUserAskedForAiAssistance, setHasUserAskedForAiAssistance] = useState<boolean>(false);
	const {
		data: {
			petition: { petitionStarterUpdates },
		},
	} = useStarterDashboardV2PageData();

	const shouldShowSuggestedTemplateNotice =
		!hasUserAskedForAiAssistance && !!petitionStarterUpdates && petitionStarterUpdates.totalCount === 0;
	const handleUserClickSuggestionAi = useCallback(() => {
		setHasUserAskedForAiAssistance(true);
	}, [setHasUserAskedForAiAssistance]);

	return {
		data: {
			shouldShowSuggestedTemplateNotice,
			isTemplateFilled: hasUserAskedForAiAssistance,
		},
		actions: {
			handleUserClickSuggestionAi,
		},
	};
}
